<template>
  <div>
    <v-autocomplete
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="Lista"
      item-text="descripcion_documento"
      item-value="id_tipo_documento"
      label="Tipo Doc."
      persistent-hint
      return-object
      @change="$emit('input', select.id_tipo_documento)"
      hide-details
    ></v-autocomplete>
    <v-text-field
      outlined
      dense
      label="Tipo Doc."
      v-if="readonly===true"
      readonly
      filled
      :value="select.descripcion_documento"
      hide-details
    ></v-text-field>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      select: {
        id_tipo_documento: 0,
        descripcion_documento: ""
      }
    };
  },
  computed: {
    ...mapState("tipodocumento", ["Lista"]),
    lista: function() {
      let l = [...this.Lista];
      l.push({
        id_tipo_documento: 0,
        descripcion_documento: " --Seleccione-- "
      });
      return l;
    }
  },
  methods: {
    ...mapActions("tipodocumento", ["set"]),
    seleccionar(id) {
      if (id) {
        let pr = this.lista.find(x => x.id_tipo_documento == id);
        if (pr) {
          this.select = pr;
        } else {
          this.seleccionar("0");
        }
      }
    }
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.seleccionar(newVal);
    }
  }
};
</script>

<style>
</style>